import { render, staticRenderFns } from "./DetailedReport.vue?vue&type=template&id=15b9b39d"
import script from "./DetailedReport.vue?vue&type=script&lang=js"
export * from "./DetailedReport.vue?vue&type=script&lang=js"
import style0 from "./DetailedReport.vue?vue&type=style&index=0&id=15b9b39d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports